// src/redux/slices/cmsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { pagesService } from '../../services/pagesService.js'
import cmsService from '../../services/cmsService.js'
import { handleApiError } from '../../utils/handleApiError.js'

export const fetchPages = createAsyncThunk(
    'cms/fetchPages',
    async (_, { rejectWithValue }) => {
        try {
            const response = await pagesService.getPages()
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const fetchPageBySlug = createAsyncThunk(
    'cms/fetchPageBySlug',
    async (slug, { rejectWithValue }) => {
        try {
            const response = await pagesService.getPageBySlug(slug)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

// export const updateSection = createAsyncThunk(
//     'cms/updateSection',
//     async ({ slug, sectionKey, data }, { rejectWithValue }) => {
//         try {
//             const response = await pagesService.updateSection(slug, sectionKey, data)
//             return { slug, sectionKey, data: response }
//         } catch (error) {
//             return rejectWithValue(handleApiError(error))
//         }
//     }
// )

// export const toggleSectionVisibility = createAsyncThunk(
//     'cms/toggleSectionVisibility',
//     async ({ slug, sectionKey, isVisible }, { rejectWithValue }) => {
//         try {
//             const response = await pagesService.toggleSectionVisibility(slug, sectionKey, isVisible)
//             return { slug, sectionKey, isVisible: response.isVisible }
//         } catch (error) {
//             return rejectWithValue(handleApiError(error))
//         }
//     }
// )

export const updateSection = createAsyncThunk(
    'cms/updateSection',
    async ({ slug, sectionKey, data }, { rejectWithValue }) => {
        try {
            const response = await cmsService.updateSection(slug, sectionKey, data);
            return response.page;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const toggleSectionVisibility = createAsyncThunk(
    'cms/toggleSectionVisibility',
    async ({ slug, sectionKey, isVisible }, { rejectWithValue }) => {
        try {
            const response = await cmsService.toggleSectionVisibility(slug, sectionKey, isVisible);
            return response.page;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const cmsSlice = createSlice({
    name: 'cms',
    initialState: {
        pages: [],
        currentPage: null,
        loading: false,
        error: null
    },
    reducers: {
        clearCurrentPage: (state) => {
            state.currentPage = null
        },
        clearError: (state) => {
            state.error = null
        },
        updateCurrentPageSection: (state, action) => {
            const { slug, sectionKey, data } = action.payload;
            if (state.currentPage && state.currentPage.slug === slug) {
                const sectionIndex = state.currentPage.sections.findIndex(
                    section => section.key === sectionKey
                );
                if (sectionIndex !== -1) {
                    state.currentPage.sections[sectionIndex].data = {
                        ...state.currentPage.sections[sectionIndex].data,
                        ...data
                    };
                }
            }
        },
        // Add a reducer to toggle visibility in current page
        toggleCurrentPageSectionVisibility: (state, action) => {
            const { slug, sectionKey, isVisible } = action.payload;
            if (state.currentPage && state.currentPage.slug === slug) {
                const sectionIndex = state.currentPage.sections.findIndex(
                    section => section.key === sectionKey
                );
                if (sectionIndex !== -1) {
                    state.currentPage.sections[sectionIndex].isVisible = isVisible;
                }
            }
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Pages
            .addCase(fetchPages.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchPages.fulfilled, (state, action) => {
                state.loading = false
                state.pages = action.payload?.data?.pages || []
                state.error = null
            })
            .addCase(fetchPages.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Fetch Page by Slug
            .addCase(fetchPageBySlug.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchPageBySlug.fulfilled, (state, action) => {
                state.loading = false
                state.currentPage = action.payload?.data?.page || null
                state.error = null
            })
            .addCase(fetchPageBySlug.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // // Update Section
            // .addCase(updateSection.fulfilled, (state, action) => {
            //     const { slug, sectionKey, data } = action.payload
            //     if (state.currentPage && state.currentPage.slug === slug) {
            //         const sectionIndex = state.currentPage.sections.findIndex(s => s.key === sectionKey)
            //         if (sectionIndex !== -1) {
            //             state.currentPage.sections[sectionIndex].data = data
            //         }
            //     }
            // })
            // // Toggle Section Visibility
            // .addCase(toggleSectionVisibility.fulfilled, (state, action) => {
            //     const { slug, sectionKey, isVisible } = action.payload
            //     if (state.currentPage && state.currentPage.slug === slug) {
            //         const sectionIndex = state.currentPage.sections.findIndex(s => s.key === sectionKey)
            //         if (sectionIndex !== -1) {
            //             state.currentPage.sections[sectionIndex].isVisible = isVisible
            //         }
            //     }
            // })
            .addCase(updateSection.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSection.fulfilled, (state, action) => {
                state.loading = false;
                state.currentPage = action.payload;
            })
            .addCase(updateSection.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export const { clearCurrentPage, clearError, updateCurrentPageSection, toggleCurrentPageSectionVisibility } = cmsSlice.actions
export default cmsSlice.reducer